import React, { useState } from 'react';

const Header = () => {

    const productSchema = {
        "@context": "http://schema.org",
        "@type": "Product",
        "name": "Awesome Product",
        "description": "This is an awesome product that does amazing things.",
        "image": "https://www.example.com/product-image.jpg",
        "brand": {
            "@type": "Winklix",
            "name": "Brand Name"
        },
        "sku": "12345",
        "offers": {
            "@type": "Offer",
            "url": "https://www.winklix.com/service-now/",
            "priceCurrency": "USD",
            "price": "99.99",
            "priceValidUntil": "2025-12-31",
            "itemCondition": "http://schema.org/NewCondition",
            "availability": "http://schema.org/InStock"
        }
    };


    const [activeSubMenu, setActiveSubMenu] = useState(null);

    const handleMouseEnter = (index) => {
        setActiveSubMenu(index);
    };

    const handleMouseLeave = () => {
        setActiveSubMenu(null);
    };

    return (
        <div className="navbar" style={{ marginTop: '-71px' }}>
            <div className="wrap-all">
                <div className="container">
                    <div className="row  show_hide_menu">
                        <div className="menu_list">
                            <div className="col-md-2  col-lg-2  col-xs-12  col-sm-12">
                                <div className="logo_new col-100 left">
                                    <a href="https://www.winklix.com" aria-label="winklix logo">
                                        <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/logo.webp' className="img-responsive" alt="winklix logo" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-10  col-lg-10 col-xs-12  col-sm-12">
                                <ul className="top_menu  float-right">
                                    <li><a href="https://www.winklix.com/about">About</a></li>
                                    <li><a href="https://www.winklix.com/jobs">Career</a></li>
                                    <li><a href="https://winklix.com/case/">Case Study</a></li>
                                    <li className="droopmenu-parent" aria-haspopup="true">
                                        <a href="#" aria-expanded="false"><img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/phone.webp' alt='phone' />
                                            <span className="droopmenu-indicator"><em></em></span><em className="droopmenu-topanim"></em></a><div className="dm-arrow"></div>
                                        <ul>
                                            <li className="number">
                                                <a href="tel:+13477462125" title="winklix usa ">
                                                    <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/us.webp' alt='us' /><span className="contact-number">+1.347.746.2125</span>
                                                </a>
                                            </li>
                                            <li className="number">
                                                <a href="tel:+918882313131" title="winklix india mobile">
                                                    <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/flag.webp' alt='flag' /><span className="contact-number">+91-8882.313131</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="droopmenu-parent  port" aria-haspopup="true">
                                        <a href="#" aria-expanded="false"><img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/email.webp' alt='email' />
                                            <span className="droopmenu-indicator"><em></em></span><em className="droopmenu-topanim"></em></a><div className="dm-arrow"></div>
                                        <ul>
                                            <li className="number">
                                                <a href="mailto:info@winklix.com" title="winklix india mobile">
                                                    <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/flag.webp' alt='falg' /><span className="contact-number">sales@winklix.com</span>
                                                </a>
                                            </li>
                                            <li className="number">
                                                <a href="mailto:info@winklix.com" title="winklix usa ">
                                                    <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/us.webp' alt='us' /><span className="contact-number">info@winklix.com</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="estimation"><a href="https://www.winklix.com/contact">Contact Us</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="menu-button">
                        <input id="dropdown-button" type="checkbox" className="dropdown-toggle" />
                        <label className="dropdown-label" htmlFor="dropdown-button">
                            <div className="icon-bar1"></div>
                            <div className="icon-bar2"></div>
                            <div className="icon-bar3"></div>
                        </label>
                        <div className="menu-slide-from-left" id="menu">
                            <div className="background_bg">
                                <a href="http://www.winklix.com/digital-transformation">
                                    <div className="col-md-4  col-lg-4  col-xs-12  col-sm-12  service_heading">
                                        <h3 style={{ fontSize: '25px', textTransform: 'capitalize', fontFamily: 'Oswald, sans-serif' }}>Winklix:IT</h3>
                                    </div>
                                </a>
                                <a href="http://www.winklix.com/mobile-app-development-services">
                                    <div className="col-md-4  col-lg-4  col-xs-12  col-sm-12  service_heading"><h3>Solution</h3>
                                    </div>
                                </a>
                                <a href="http://www.winklix.com/sap"><div className="col-md-4  col-lg-4  col-xs-12  col-sm-12  service_heading">
                                    <h3>Simplified</h3>
                                </div>
                                </a>
                            </div>
                            <div className="inner-menu-slide-from-left">
                                <div className="right_section col-100 left">
                                    <ul className="menu_inner">
                                        <li
                                            onMouseEnter={() => handleMouseEnter(0)}
                                            onMouseLeave={handleMouseLeave}
                                        ><a href="#0">Services</a>
                                            <div className={`sub_li_list ${activeSubMenu === 0 ? 'show' : ''}`}>
                                                <div className="col-md-12 col-lg-12  col-sm-12  col-xs-12  padding-none">
                                                    <h2>Services</h2></div>
                                                <ul className="category_list">
                                                    <li>
                                                        <a href="http://www.winklix.com/salesforce/">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Salesforce Services</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/#">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Odoo</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://winklix.com/service-now/">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Service Now</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.winklix.com/artificial-intelligence/">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Generative AI & ML</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/big-data-company">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Big Data</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/software/">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Software Development </h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/mobile-app-development-services">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Mobile App Development</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href=" http://www.winklix.com/digital-transformation">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Digital Transformation</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/ui-ux">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>UX & UI Design</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href=" http://www.winklix.com/quality-assurance">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Testing & QA</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/digital-marketing">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Digital Marketing</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/application-support-maintenance">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Application Support & Maintenance</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/web-development">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Website Development</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.winklix.com/software-testing/">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Software Testing</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li
                                            onMouseEnter={() => handleMouseEnter(1)}
                                            onMouseLeave={handleMouseLeave}
                                        ><a href="#0">Salesforce</a>
                                            <div className={`sub_li_list ${activeSubMenu === 1 ? 'show' : ''}`}>
                                                <div className="col-md-12 col-lg-12  col-sm-12  col-xs-12">
                                                    <h2>Customer 360</h2></div>
                                                <ul className="category_list">
                                                    <li>
                                                        <a href="https://www.winklix.com/salesforce/sales-cloud">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Salesforce Sales Cloud</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.winklix.com/salesforce/service-cloud">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Salesforce Service Cloud</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.winklix.com/salesforce/marketing-cloud">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Salesforce Marketing Cloud</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.winklix.com/salesforce/community-cloud">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Salesforce Community Cloud</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://winklix.com/salesforce/financial-service-cloud/">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Salesforce Financial Service Cloud</h4>
                                                            </div>

                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.winklix.com/cpq">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Salesforce CPQ</h4>
                                                            </div>

                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.winklix.com/salesforce/commerce-cloud/">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Salesforce Commerce Cloud</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.winklix.com/salesforce">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>AI For Salesforce</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>

                                        </li>
                                        <li
                                            onMouseEnter={() => handleMouseEnter(2)}
                                            onMouseLeave={handleMouseLeave}
                                        ><a href="#0">Products</a>
                                            <div className={`sub_li_list ${activeSubMenu === 2 ? 'show' : ''}`}>
                                                <div className="col-md-12 col-lg-12  col-sm-12  col-xs-12  padding-none">
                                                    <h2>Products</h2></div>
                                                <ul className="category_list">
                                                    <li>
                                                        <a href="http://www.winklix.com/crm-erp-products">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>CRM & ERP</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/hotel-management-software">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Hotel Management Software</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/pos-software-development">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>POS Software</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/school-management-software">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>School Management</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/virtual-classroom">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Virtual classroom</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.winklix.com/aws-live-class-software-development">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>AWS Live classes Software</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/hcm">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Human Capital Management</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/purchase-management-software">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Purchase Management Software</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/complain-management-and-support-software">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Complian Management Software</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li
                                            onMouseEnter={() => handleMouseEnter(3)}
                                            onMouseLeave={handleMouseLeave}
                                        ><a href="#0">Company</a>
                                            <div className={`sub_li_list ${activeSubMenu === 3 ? 'show' : ''}`}>

                                                <div className="col-md-12 col-lg-12  col-sm-12  col-xs-12  padding-none">
                                                    <h2>Company</h2>
                                                </div>
                                                <ul className="category_list">
                                                    <li>
                                                        <a href="http://www.winklix.com/about">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>About Us</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/jobs">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Career</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/blog">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Blog</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://winklix.com/case-study/">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Case Study</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/technology">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Technology</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://support.winklix.com">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Support</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>

                                        </li>
                                        <li
                                            onMouseEnter={() => handleMouseEnter(4)}
                                            onMouseLeave={handleMouseLeave}
                                        ><a href="#0">Latest Thinking</a>
                                            <div className={`sub_li_list ${activeSubMenu === 4 ? 'show' : ''}`}>
                                                <div className="col-md-12 col-lg-12  col-sm-12  col-xs-12  padding-none">
                                                    <h2>Innovation In Technology</h2></div>
                                                <ul className="category_list">
                                                    <li>
                                                        <a href="https://www.winklix.com/quality-assurance">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Product Engineering</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/internet-of-things">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>Internet Of Things</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/artificial-intelligence(ai)-development-company">
                                                            <div className="category_list_box  col-100  left">

                                                                <h4>AI / ML</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/blockchain">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Blockchain</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="http://www.winklix.com/cloud">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Cloud Computing</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="https://www.winklix.com/big-data-company">
                                                            <div className="category_list_box  col-100  left">
                                                                <h4>Big Data</h4>
                                                            </div>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        {/* <li><a href="http://www.winklix.com/jobs"> Developers On Demand</a></li> */}
                                        <li><a href="http://www.winklix.com/contact">Contact</a></li>
                                    </ul>
                                    <div className="col-md-12  col-lg-12">
                                        <div className="right_contact_details  col-100  left">
                                            <div className="col-md-12  col-lg-16  col-xs-12  col-sm-12 pd_tb_5px">
                                                <ul>
                                                    <li><img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/ai/service-now/logo.webp' className="img-responsive" alt="custom software development company" /></li>
                                                    <li><p><strong>Headquarter:</strong><br />New York , USA:116W, 45TH Street , New York ,NY,10036 , USA </p></li>
                                                </ul>
                                            </div>
                                            <div className="col-md-12  col-lg-16  col-xs-12  col-sm-12  pd_tb_5px">
                                                <ul>
                                                    <li><p><strong>USA :</strong>+1-(347)-746-2125</p></li>
                                                    <li><p><strong>INDIA :</strong> +91-8882-31-31-31 </p></li>
                                                    <li><a href="mailto:info@winklix.com" style={{ textDecoration: 'none' }}><p><strong>Mail Us: </strong> info@winklix.com</p></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="social_links col-100  left">
                                            <ul>
                                                <li><a href="http://www.facebook.com/Winklix/" aria-label="Visit our Facebook page" ><i className="fab fa-facebook" target="_blank"></i></a></li>
                                                <li><a href="http://www.youtube.com/channel/UCS9W-DHO95H39gavX8ICcdA" target="_blank" aria-label="Visit our Youtube page"><i className="fab fa-youtube"></i></a></li>
                                                <li><a href="http://twitter.com/winklix" target="_blank" aria-label="Visit our Twitter page"><i className="fab fa-twitter"></i></a></li>
                                                <li><a href="http://in.linkedin.com/company/winklix" target="_blank" aria-label="Visit our Linkedin page"><i className="fab fa-linkedin"></i></a></li>
                                                <li><a href="http://www.instagram.com/winklixit/" target="_blank" aria-label="Visit our Instagram page" ><i className="fab fa-instagram"></i></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;